/* eslint-disable  */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// actions
import { updateSearchQuery, setAutocompleteResults, setFiltersVisibility } from '../actions';

// components
import SearchInputField from '../components/SearchInput/SearchInput';

// containers
import DropdownContainer from './DropdownContainer';

// helpers
import MapUtils from '../lib/MapUtils/MapUtils';

// constants
import { MOBILE } from '../constants';

/**
 * @description SearchInput container handles most logic for dispatching trip information
 *
 * @param {object} props - Component props
 * @param {object} props.content - Authorable strings
 *
 * @returns {<SearchInput></SearchInput>}
 */
class SearchInput extends Component {
  constructor(props) {
    super(props);

    this.state = {
      keyPressed: '',
      geocoderMounted: false,
      focused: false,
    };

    // Refs.
    this.inputRef = null;
    // eslint-disable-next-line no-return-assign
    this.setInputRef = ref => (this.inputRef = ref);

    this.containerRef = null;

    // Event handlers.
    this.handleClick = this.handleClick.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.shouldCancel = this.shouldCancel.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
    this.handleFilterClick = this.handleFilterClick.bind(this);
    this.handleCancelClick = this.handleCancelClick.bind(this);
  }

  componentWillReceiveProps(newProps) {
    if (newProps.searchedLocation !== this.props.searchedLocation) {
      this.changeFocus({ focus: false });
    }
  }

  componentDidUpdate() {
    const { mapLoaded } = this.props;
    const { geocoderMounted } = this.state;

    if (mapLoaded && !geocoderMounted) {
      this.initGeocoder();
    }
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClick);
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClick);
  }

  changeFocus({ focus = false }) {
    if (this.inputRef) {
      if (focus) {
        this.inputRef.focus();
      } else {
        this.inputRef.blur();
      }
    }
  }

  onInputChange(e) {
    this.props.dispatchUpdateSearchQuery(e.target.value);
  }

  onKeyPress(e) {
    const { key } = e;
    if (key === 'ArrowUp' || key === 'ArrowDown' || key === 'Enter' || key === 'Escape') {
      this.setState({ keyPressed: key }, () => {
        this.setState({ keyPressed: '' });
      });
    }
  }

  onFocus({ event, focus }) {
    // Hack to push the focus handling to the back of the event queue (behind click handling).
    setTimeout(() => this.setState({ focused: focus }), 10);
  }

  handleClick(e) {
    if (this.containerRef && !this.containerRef.contains(e.target)) {
      this.props.dispatchSetAutocompleteResults([]);
      this.inputRef.blur();
    }
  }

  handleButtonClick(e) {
    if (this.shouldCancel()) {
      this.handleCancelClick();
    } else {
      this.handleFilterClick();
    }
  }

  handleCancelClick() {
    this.props.dispatchSetAutocompleteResults([]);
    this.props.dispatchUpdateSearchQuery('');
  }

  handleFilterClick() {
    this.props.dispatchSetFiltersVisibility(true);
  }

  shouldCancel() {
    return (this.props.userInput && this.state.focused) || window.outerWidth > MOBILE;
  }

  initGeocoder() {
    this.geocoder = MapUtils.getGeocoder();

    // let the container know that the geocoder service has been instantiated
    this.mountGeoCoder();
  }

  mountGeoCoder() {
    this.setState(prevState => {
      return {
        ...prevState,
        geocoderMounted: true,
      };
    });
  }

  render() {
    const isHidden = !!this.props.selected;
    const isDropdown = this.props.searchResults && this.props.searchResults.length > 0;
    // const isLowered = this.props.serviceAvailable;
    const isLowered = true;
    const iconClass = this.shouldCancel() ? 'icon--cancel' : 'icon--filter';

    return (
      <div
        ref={r => (this.containerRef = r)}
        className={`findus-search-input ${isHidden ? 'findus-search-input--hidden' : ''} ${
          isDropdown ? 'findus-search-dropdown--shown' : ''
        } ${isLowered ? 'findus-search-input--lowered' : ''}`}
      >
        <SearchInputField
          className="search-input tsla-icon-search"
          render={this.render}
          placeholderText={this.props.content.search.placeholder}
          handleChange={this.onInputChange}
          handleKeyPress={this.onKeyPress}
          handleFocus={this.onFocus}
          setRef={this.setInputRef}
          handleClick={this.handleButtonClick}
          value={this.props.userInput}
          focused={this.state.focused}
          icon={iconClass}
        />
        <DropdownContainer keyPressed={this.state.keyPressed} focused={this.state.focused} />
      </div>
    );
  }
}

SearchInput.propTypes = {
  loaded: PropTypes.bool.isRequired,
  dispatchUpdateSearchQuery: PropTypes.func.isRequired,
  content: PropTypes.object,
  searchedLocation: PropTypes.object,
  userInput: PropTypes.string,
  serviceAvailable: PropTypes.bool.isRequired,
};

SearchInput.defaultProps = {
  content: {},
  loaded: false,
  searchedLocation: null,
  userInput: null,
};

const mapStateToProps = state => {
  return {
    content: state.content,
    loaded: state.map.mapLoaded,
    searchedLocation: state.search.selectedSearchResult,
    selected: state.locations.selected,
    searchResults: state.search.searchResults,
    userInput: state.search.userInput,
    serviceAvailable: state.service.available,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    dispatchUpdateSearchQuery: userInput => {
      dispatch(updateSearchQuery(userInput));
    },
    dispatchSetAutocompleteResults: searchResults => {
      dispatch(setAutocompleteResults(searchResults));
    },
    dispatchSetFiltersVisibility: visible => {
      dispatch(setFiltersVisibility(visible));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchInput);
